import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import './Software Solutions.css';
import software02 from "./Images/Gimini_03.png";
import {
    FaTools,
    FaNetworkWired,
    FaChartLine,
    FaUserShield,
    FaCogs,
    FaLifeRing
} from "react-icons/fa";

const SoftwareSolutions = () => {
    const navigate = useNavigate();

    const handleCardClick = (path) => {
        navigate(path);
    };

    return (
        <div className="software-solutions-container">



            <Helmet>
        <title>Custom Software Solutions - APTech Solution</title>
        <meta
          name="description"
          content="We provide tailored software solutions for businesses of all sizes, including enterprise software, ERP systems, and cloud-based solutions."
        />
      </Helmet>
            {/* Hero Section */}
            <section className="software-hero">
                <h1>Software Solutions</h1>
                <p>Custom software tailored to streamline your operations, enhance productivity, and drive innovation.</p>
                <img src={software02} alt="Software Solutions Banner" />
                {/* <img src="https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ25yMWU5aTB6aHM4eXBhd3EwY2prNnNtMnd4anYyN2l5NHlobjJxbSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/qgQUggAC3Pfv687qPC/giphy.gif" alt="Software Solutions Banner" /> */}
            </section>

            {/* Software Types */}
            <section className="software-types">
                <h2>Our Software Expertise</h2>
                <div className="software-types-grid">
                    <div
                        className="software-card"
                        onClick={() => handleCardClick('/EnterpriseSoftware')}

                    >
                        Enterprise Software
                    </div>
                    <div
                        className="software-card"
                        onClick={() => handleCardClick('/SalesForceDevelopment')}

                    >CRM Solutions</div>
                    <div
                        className="software-card"
                        onClick={() => handleCardClick('/ERPSystem')}

                    >ERP Systems</div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="software-why-choose">
                <h2>Why Choose Our Software Solutions?</h2>
                <div className="software-features-row">
                    <div className="software-feature-card gradient-border-card ">
                        <FaTools />
                        <h3>Tailored Development</h3>
                        <p>We build from scratch, fully aligned with your unique business needs.</p>
                    </div>
                    <div className="software-feature-card gradient-border-card ">
                        <FaNetworkWired />
                        <h3>System Integration</h3>
                        <p>Seamlessly integrate with existing platforms, databases, and APIs.</p>
                    </div>
                    <div className="software-feature-card gradient-border-card ">
                        <FaChartLine />
                        <h3>Data-Driven Design</h3>
                        <p>Solutions built with real-time analytics, dashboards, and insights.</p>
                    </div>
                </div>
                <div className="software-features-row  ">
                    <div className="software-feature-card gradient-border-card">
                        <FaUserShield />
                        <h3>Secure Architecture</h3>
                        <p>Built with enterprise-grade security, authentication, and compliance.</p>
                    </div>
                    <div className="software-feature-card gradient-border-card ">
                        <FaCogs />
                        <h3>Scalable Codebase</h3>
                        <p>Modular structure to support growth, updates, and flexibility.</p>
                    </div>
                    <div className="software-feature-card gradient-border-card ">
                        <FaLifeRing />
                        <h3>End-to-End Support</h3>
                        <p>From consultation to deployment and long-term support.</p>
                    </div>
                </div>
            </section>

            {/* Development Process */}
            <section className="software-process">
                <h2>Our Development Lifecycle</h2>
                <div className="software-process-steps">
                    <div className="software-step"><span>1</span> Requirement Analysis</div>
                    <div className="software-step"><span>2</span> System Design</div>
                    <div className="software-step"><span>3</span> Agile Development</div>
                    <div className="software-step"><span>4</span> QA & Testing</div>
                    <div className="software-step"><span>5</span> Deployment</div>
                    <div className="software-step"><span>6</span> Maintenance & Scaling</div>
                </div>
            </section>

            {/* CTA */}
            <section className="software-cta">
                <h2>Transform Your Vision into Software</h2>
                <p>Let us help you build intelligent, secure, and scalable software.</p>

                <Link to="/contact" state={{ scrollTo: "form" }}>
                    <button className="cta-button">Discuss Your Project</button>
                </Link>

                {/* <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Discuss Your Project</button>
                </a> */}

            </section>
        </div>
    );
};

export default SoftwareSolutions;
